export var AccountVerificationMethod;
(function (AccountVerificationMethod) {
    AccountVerificationMethod["email"] = "email";
    AccountVerificationMethod["txt"] = "txt";
    AccountVerificationMethod["selfServiceLink"] = "selfServiceLink";
    AccountVerificationMethod["selfServiceQr"] = "selfServiceQr";
})(AccountVerificationMethod || (AccountVerificationMethod = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["practice"] = "practice";
    ActivityType["lift"] = "lift";
    ActivityType["conditioning"] = "conditioning";
    ActivityType["competition"] = "competition";
    ActivityType["class"] = "class";
})(ActivityType || (ActivityType = {}));
export var AiType;
(function (AiType) {
    AiType["generated"] = "generated";
    AiType["transcribed"] = "transcribed";
})(AiType || (AiType = {}));
export var AnthropometryEntryField;
(function (AnthropometryEntryField) {
    AnthropometryEntryField["percentBodyFat"] = "percentBodyFat";
    AnthropometryEntryField["height"] = "height";
    AnthropometryEntryField["weight"] = "weight";
    AnthropometryEntryField["leanBodyMass"] = "leanBodyMass";
})(AnthropometryEntryField || (AnthropometryEntryField = {}));
export var AnthropometryEntryMetricField;
(function (AnthropometryEntryMetricField) {
    AnthropometryEntryMetricField["percentBodyFat"] = "percentBodyFat";
    AnthropometryEntryMetricField["heightInCm"] = "heightInCm";
    AnthropometryEntryMetricField["weightInKg"] = "weightInKg";
    AnthropometryEntryMetricField["leanBodyMass"] = "leanBodyMass";
})(AnthropometryEntryMetricField || (AnthropometryEntryMetricField = {}));
export var AnthropometryEntryType;
(function (AnthropometryEntryType) {
    AnthropometryEntryType["estimate"] = "estimate";
    AnthropometryEntryType["dexa"] = "dexa";
    AnthropometryEntryType["bodpod"] = "bodpod";
    AnthropometryEntryType["bioelectricalImpedance"] = "bioelectricalImpedance";
    AnthropometryEntryType["isak"] = "isak";
    AnthropometryEntryType["weighIn"] = "weighIn";
})(AnthropometryEntryType || (AnthropometryEntryType = {}));
export var AnthropometryFormField;
(function (AnthropometryFormField) {
    AnthropometryFormField["height"] = "height";
    AnthropometryFormField["weight"] = "weight";
    AnthropometryFormField["percentBodyFat"] = "percentBodyFat";
})(AnthropometryFormField || (AnthropometryFormField = {}));
export var AthleteAnthropometryFilter;
(function (AthleteAnthropometryFilter) {
    AthleteAnthropometryFilter["hasAnthropometryEntry"] = "has_anthropometry_entry";
    AthleteAnthropometryFilter["noAnthropometryEntry"] = "no_anthropometry_entry";
})(AthleteAnthropometryFilter || (AthleteAnthropometryFilter = {}));
export var AthleteFilter;
(function (AthleteFilter) {
    AthleteFilter["active"] = "active";
    AthleteFilter["noLinkSent"] = "no_link_sent";
    AthleteFilter["linkExpired"] = "link_expired";
    AthleteFilter["archived"] = "archived";
})(AthleteFilter || (AthleteFilter = {}));
export var BulkAssignMealPlanTemplateJobStatus;
(function (BulkAssignMealPlanTemplateJobStatus) {
    BulkAssignMealPlanTemplateJobStatus["queued"] = "QUEUED";
    BulkAssignMealPlanTemplateJobStatus["processing"] = "PROCESSING";
    BulkAssignMealPlanTemplateJobStatus["success"] = "SUCCESS";
    BulkAssignMealPlanTemplateJobStatus["partialSuccess"] = "PARTIAL_SUCCESS";
    BulkAssignMealPlanTemplateJobStatus["failed"] = "FAILED";
})(BulkAssignMealPlanTemplateJobStatus || (BulkAssignMealPlanTemplateJobStatus = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["monday"] = "monday";
    DayOfWeek["tuesday"] = "tuesday";
    DayOfWeek["wednesday"] = "wednesday";
    DayOfWeek["thursday"] = "thursday";
    DayOfWeek["friday"] = "friday";
    DayOfWeek["saturday"] = "saturday";
    DayOfWeek["sunday"] = "sunday";
})(DayOfWeek || (DayOfWeek = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["ios"] = "IOS";
    DeviceType["android"] = "ANDROID";
})(DeviceType || (DeviceType = {}));
export var ExchangeProgressViews;
(function (ExchangeProgressViews) {
    ExchangeProgressViews["all"] = "all";
    ExchangeProgressViews["none"] = "none";
})(ExchangeProgressViews || (ExchangeProgressViews = {}));
export var ExchangeType;
(function (ExchangeType) {
    ExchangeType["starch"] = "starch";
    ExchangeType["fruit"] = "fruit";
    ExchangeType["vegetable"] = "vegetable";
    ExchangeType["protein"] = "protein";
    ExchangeType["dairy"] = "dairy";
    ExchangeType["fat"] = "fat";
})(ExchangeType || (ExchangeType = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["dietitianMenuSuggestions"] = "dietitianMenuSuggestions";
    FeatureFlag["athleteMenuSuggestions"] = "athleteMenuSuggestions";
})(FeatureFlag || (FeatureFlag = {}));
export var FoodCategoryType;
(function (FoodCategoryType) {
    FoodCategoryType["carbohydrate"] = "carbohydrate";
    FoodCategoryType["protein"] = "protein";
    FoodCategoryType["fats"] = "fats";
    FoodCategoryType["combination"] = "combination";
})(FoodCategoryType || (FoodCategoryType = {}));
export var FoodDataSource;
(function (FoodDataSource) {
    FoodDataSource["manual"] = "manual";
    FoodDataSource["usda"] = "usda";
    FoodDataSource["nutritionix"] = "nutritionix";
    FoodDataSource["bonAppetit"] = "bonAppetit";
    FoodDataSource["compass"] = "compass";
    FoodDataSource["sodexo"] = "sodexo";
    FoodDataSource["cbord"] = "cbord";
    FoodDataSource["restaurant"] = "restaurant";
    FoodDataSource["mccance"] = "mccance";
})(FoodDataSource || (FoodDataSource = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["compass"] = "compass";
    IntegrationType["cbord"] = "cbord";
    IntegrationType["bonAppetit"] = "bonAppetit";
    IntegrationType["sodexo"] = "sodexo";
})(IntegrationType || (IntegrationType = {}));
export var MacroProgressViews;
(function (MacroProgressViews) {
    MacroProgressViews["all"] = "all";
    MacroProgressViews["hideNumbers"] = "hideNumbers";
    MacroProgressViews["none"] = "none";
})(MacroProgressViews || (MacroProgressViews = {}));
export var MacroType;
(function (MacroType) {
    MacroType["cho"] = "cho";
    MacroType["pro"] = "pro";
    MacroType["fat"] = "fat";
})(MacroType || (MacroType = {}));
export var MealPlanType;
(function (MealPlanType) {
    MealPlanType["macro"] = "macro";
    MealPlanType["exchange"] = "exchange";
})(MealPlanType || (MealPlanType = {}));
export var MealType;
(function (MealType) {
    MealType["breakfast"] = "breakfast";
    MealType["lunch"] = "lunch";
    MealType["dinner"] = "dinner";
    MealType["snack"] = "snack";
    MealType["meal"] = "meal";
})(MealType || (MealType = {}));
export var MenuItemSuggestionCategory;
(function (MenuItemSuggestionCategory) {
    MenuItemSuggestionCategory["combo"] = "combo";
    MenuItemSuggestionCategory["main"] = "main";
    MenuItemSuggestionCategory["protein"] = "protein";
    MenuItemSuggestionCategory["starch"] = "starch";
    MenuItemSuggestionCategory["vegetable"] = "vegetable";
    MenuItemSuggestionCategory["fruit"] = "fruit";
    MenuItemSuggestionCategory["other"] = "other";
})(MenuItemSuggestionCategory || (MenuItemSuggestionCategory = {}));
export var MenuOrderItemStatus;
(function (MenuOrderItemStatus) {
    MenuOrderItemStatus["new"] = "new";
    MenuOrderItemStatus["cooking"] = "cooking";
    MenuOrderItemStatus["done"] = "done";
    MenuOrderItemStatus["cancelled"] = "cancelled";
})(MenuOrderItemStatus || (MenuOrderItemStatus = {}));
export var MobileUpdateType;
(function (MobileUpdateType) {
    MobileUpdateType["force"] = "force";
    MobileUpdateType["suggest"] = "suggest";
})(MobileUpdateType || (MobileUpdateType = {}));
export var NotemealAccountType;
(function (NotemealAccountType) {
    NotemealAccountType["athlete"] = "athlete";
    NotemealAccountType["dietitian"] = "dietitian";
    NotemealAccountType["chef"] = "chef";
})(NotemealAccountType || (NotemealAccountType = {}));
export var NutrientDietaryReferenceIntakeType;
(function (NutrientDietaryReferenceIntakeType) {
    NutrientDietaryReferenceIntakeType["rda"] = "RDA";
    NutrientDietaryReferenceIntakeType["ul"] = "UL";
    NutrientDietaryReferenceIntakeType["ai"] = "AI";
    NutrientDietaryReferenceIntakeType["dga"] = "DGA";
    NutrientDietaryReferenceIntakeType["unitsPerKcal"] = "unitsPerKcal";
})(NutrientDietaryReferenceIntakeType || (NutrientDietaryReferenceIntakeType = {}));
export var PlannedMenuOccurrence;
(function (PlannedMenuOccurrence) {
    PlannedMenuOccurrence["daily"] = "daily";
    PlannedMenuOccurrence["weekdays"] = "weekdays";
})(PlannedMenuOccurrence || (PlannedMenuOccurrence = {}));
export var PreferredContactMethodType;
(function (PreferredContactMethodType) {
    PreferredContactMethodType["email"] = "email";
    PreferredContactMethodType["phoneNumber"] = "phoneNumber";
})(PreferredContactMethodType || (PreferredContactMethodType = {}));
export var RmrMethod;
(function (RmrMethod) {
    RmrMethod["cunningham"] = "cunningham";
    RmrMethod["mifflin"] = "mifflin";
    RmrMethod["harrisBenedict"] = "harrisBenedict";
    RmrMethod["average"] = "average";
})(RmrMethod || (RmrMethod = {}));
export var RatingValue;
(function (RatingValue) {
    RatingValue["one"] = "one";
    RatingValue["two"] = "two";
    RatingValue["three"] = "three";
    RatingValue["four"] = "four";
    RatingValue["five"] = "five";
})(RatingValue || (RatingValue = {}));
export var RecipeSortDirection;
(function (RecipeSortDirection) {
    RecipeSortDirection["asc"] = "ASC";
    RecipeSortDirection["desc"] = "DESC";
})(RecipeSortDirection || (RecipeSortDirection = {}));
export var RecipeSortKey;
(function (RecipeSortKey) {
    RecipeSortKey["createdAt"] = "createdAt";
})(RecipeSortKey || (RecipeSortKey = {}));
export var RefundPolicyType;
(function (RefundPolicyType) {
    RefundPolicyType["full"] = "full";
    RefundPolicyType["labor"] = "labor";
})(RefundPolicyType || (RefundPolicyType = {}));
export var Role;
(function (Role) {
    Role["athlete"] = "athlete";
    Role["dietitian"] = "dietitian";
    Role["chef"] = "chef";
    Role["foodmanager"] = "foodmanager";
    Role["kiosk"] = "kiosk";
    Role["nonRdAdmin"] = "nonRdAdmin";
})(Role || (Role = {}));
export var SexType;
(function (SexType) {
    SexType["male"] = "male";
    SexType["female"] = "female";
})(SexType || (SexType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["asc"] = "ASC";
    SortOrder["desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var TagCombinationMethod;
(function (TagCombinationMethod) {
    TagCombinationMethod["union"] = "union";
    TagCombinationMethod["intersection"] = "intersection";
})(TagCombinationMethod || (TagCombinationMethod = {}));
export var TagConditionType;
(function (TagConditionType) {
    TagConditionType["position"] = "position";
    TagConditionType["tag"] = "tag";
    TagConditionType["team"] = "team";
})(TagConditionType || (TagConditionType = {}));
export var TeamworksGender;
(function (TeamworksGender) {
    TeamworksGender["m"] = "M";
    TeamworksGender["f"] = "F";
})(TeamworksGender || (TeamworksGender = {}));
export var TeamworksGroupType;
(function (TeamworksGroupType) {
    TeamworksGroupType["team"] = "team";
    TeamworksGroupType["userType"] = "user_type";
    TeamworksGroupType["athleteStatus"] = "athlete_status";
    TeamworksGroupType["position"] = "position";
    TeamworksGroupType["academicYear"] = "academic_year";
})(TeamworksGroupType || (TeamworksGroupType = {}));
//# sourceMappingURL=types.js.map